export default __webpack_public_path__ + "static/media/test.ccb8f4d0.png";